<template>
  <div>
    <v-row>
      <v-col>
        <VTextField
          hideDetails
          outlined
          disabled
          :placeholder="componentName"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VTextField
          v-model="data.type"
          outlined
          placeholder="$t('generic.fuelMeter')"
          hideDetails
          disabled
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VSelect
          v-model="data.dataSource"
          :label="$t('devices.flowMeters.sources.label')"
          hideDetails
          outlined
          :rules="{ required: true }"
          :items="sources"
          itemValue="value"
          itemText="name"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- <v-row v-if="data.dataSource === SOURCE_IOT">
      <v-col>
        <VSelect
          v-model="data.flowMeterHub"
          hideDetails
          outlined
          :label="$t('devices.flowMetersHubs.name')"
          :rules="{ required: true }"
          :items="availableMetersHubs"
          @focus="getFlowmeterHubs"
          @input="updateData"
        />
      </v-col>
    </v-row> -->
    <!-- <v-row v-if="data.dataSource === SOURCE_IOT && data.flowMeterHub">
      <v-col>
        <VSelect
          v-model="data.flowMeter"
          hideDetails
          outlined
          :label="$t('devices.flowMeters.name')"
          :rules="{ required: true }"
          :items="availableMeters"
          @input="updateData"
        />
      </v-col>
    </v-row> -->
    <v-row v-if="data.dataSource === SOURCE_CONTROLLER">
      <v-col>
        <VSelect
          v-model="data.controllerHub"
          hideDetails
          outlined
          :label="$t('forms.labels.controller')"
          :items="availableControllersHubs"
          itemText="name"
          itemValue="id"
          @focus="getControllersHubs"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row v-if="data.dataSource === SOURCE_CONTROLLER && data.controllerHub">
      <v-col>
        <VSelect
          v-model="data.probe"
          hideDetails
          outlined
          :label="$t('devices.probes.name')"
          :rules="{ required: true }"
          :items="availableProbes"
          itemText="name"
          itemValue="id"
          @focus="getProbes"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row v-if="data.dataSource === SOURCE_CONTROLLER && data.controllerHub && data.probe">
      <v-col>
        <VTextField
          v-model="data.probeId"
          outlined
          hideDetails
          disabled
        />
      </v-col>
    </v-row>
    <v-row v-if="data.dataSource === SOURCE_MANUAL">
      <v-col>
        <VTextField
          v-model="data.fuelMeterName"
          hideDetails
          outlined
          :label="$t('forms.labels.name')"
          :rules="{ required: true }"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VSelect
          v-model="data.fuelType"
          hideDetails
          :label="$t('massBalance.e4Form.boilerOperatingParameters.fuelType')"
          outlined
          :rules="{ required: true }"
          :items="fuelTypeList"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row v-if="data.fuelType">
      <v-col>
        <VSelect
          v-model="data.fuelName"
          hideDetails
          :label="$t('massBalance.e4Form.boilerOperatingParameters.fuelName')"
          outlined
          :rules="{ required: true }"
          :items="fuelNameList"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row v-if="data.fuelName">
      <v-col>
        <VSelect
          v-model="data.measurementUnit"
          :label="$t('forms.labels.measureUnit')"
          :items="units"
          outlined
          hideDetails
          @change="updateData"
        />
      </v-col>
    </v-row>
    <v-row v-if="showDensity">
      <v-col>
        <VSelect
          v-model="data.density.unit"
          :label="$t('forms.labels.densityUnit')"
          :items="densityUnits"
          :rules="{ required: true }"
          outlined
          hideDetails
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row v-if="showDensity">
      <v-col>
        <VTextField
          v-model.number="data.density.value"
          :label="$t('forms.labels.density')"
          :rules="{ required: true }"
          outlined
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import LinkMeterMixin from '@/mixins/LinkMeterMixin';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
// import { SOURCE_CONTROLLER, SOURCE_MANUAL } from '@/aquassist-shared/constants/types/flowMeters';
import { COMBUSTILES_LISTS, FUELNAMES, CONBUSTIBLES_UNITS, BIOMASS_UNITS_FOR_FUEL_NAME_EXEPTION, DENSITIES_UNITS } from '@/aquassist-shared/constants/massBalance';
import { SOURCE_CONTROLLER, SOURCE_MANUAL } from '@/aquassist-shared/constants/types/flowMeters';

export default {
    components: {
        VTextField,
        VSelect,
    },
    mixins: [
        LinkMeterMixin,
    ],
    props: {
        analysis: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            data: {
                source: null,
                fuelMeterName: null,
                flowMeterHub: null,
                type: 'fuelMeter',
                density: {
                    value: null,
                    unit: null,
                },
                probe: null,
                fuelType: null,
                fuelName: null,
                measurementUnit: null,
            },
            availableMetersHubs: [],
            availableMeters: [],
            availableControllersHubs: [],
            availableProbes: [],
            units: [],
            showDensity: false,
            fuelNameList: [],
        };
    },
    computed: {
        ...mapGetters(['site']),
        componentName() {
            return this?.analysis?.component?.name;
        },
        fuelTypeList() {
            return Object.values(COMBUSTILES_LISTS || {}).map(item => ({
                id: item,
                name: this.$t(`massBalance.e4Form.fuelTypes.${item}`),
            }));
        },
        densityUnits() {
            return Object.values(DENSITIES_UNITS || {}).map(item => ({
                id: item,
                name: item,
            }));
        },
        sources() {
            return [
                {
                    name: this.$t(`devices.flowMeters.sources.${SOURCE_CONTROLLER}`),
                    value: SOURCE_CONTROLLER,
                },
                {
                    name: this.$t(`devices.flowMeters.sources.${SOURCE_MANUAL}`),
                    value: SOURCE_MANUAL,
                },
            ];
        },
    },
    watch: {
        'data.flowMeterHub': {
            immediate: false,
            async handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    await this.getAvailableMeters(this.availableMetersHubs, this.data.flowMeterHub);
                }
            },
        },
        'data.flowMeter': {
            immediate: false,
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    const meter = this.availableMeters.find(m => m.id === newVal);
                    this.data.fuelMeterName = meter.name;
                }
            },
        },
        'data.controller': {
            immediate: false,
            async handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    await this.getProbes();
                }
            },
        },
        'data.probe': {
            immediate: false,
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    const prob = this.availableProbes.find(probe => probe.id === this.data.probe);
                    this.data.probeId = prob.probeId;
                    this.data.fuelMeterName = prob.name;
                }
            },
        },
        'data.fuelType': {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.fuelNameList = FUELNAMES[this.data.fuelType].map(item => ({
                        id: item,
                        name: this.$t(`massBalance.e4Form.fullName.${this.data.fuelType}.${item}`),
                    }));

                    this.data.fuelName = null;
                }
            },
        },
        'data.fuelName': {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    if (!this.data.fuelName) this.units = [];

                    let unitOfMeasurements = [];
                    if (this.data.fuelType === 'biomass' && BIOMASS_UNITS_FOR_FUEL_NAME_EXEPTION.includes(this.data.fuelName)) {
                        unitOfMeasurements = CONBUSTIBLES_UNITS.gasFossil;
                    } else {
                        unitOfMeasurements = this.data.fuelName ? CONBUSTIBLES_UNITS[this?.data?.fuelType] : [];
                    }
                    if (unitOfMeasurements?.length === 0) this.units = [];
                    this.units = unitOfMeasurements.map(item => ({
                        id: item,
                        name: this.$t(`massBalance.e4Form.units.${item}`),
                    }));
                }
            },
        },
        'data.measurementUnit': {
            handler() {
                this.showDensity = this.isShowDensity();
            },
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
        async getFlowmeterHubs() {
            this.availableMetersHubs = await this.getAvailableFlowMetersHubs();
        },
        async getControllersHubs() {
            this.availableControllersHubs = await this.getAvailableControllersHubs();
        },
        async getProbes() {
            this.availableProbes = await this.getAvailableProbes(this.availableControllersHubs, this.data.controllerHub);
        },
        isShowDensity() {
            const showDensity = false;
            const unitsIncludesDensity = ['l', 'm3', 'usg', 'ft3', 'bbl', 'ig'];
            if (unitsIncludesDensity.includes(this.data.measurementUnit)) return true;

            return showDensity;
        },
    },
};

</script>
